import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

import { styles as typescaleStyles } from '@material/web/typography/md-typescale-styles.js';

import { useRouter, useRoute } from 'vue-router';
import { DEFAULT_LOCALE, useI18n } from '@/composables/useI18n';
import { onBeforeMount, ref } from 'vue';
import { useRefreshToken } from '@/composables/useRefreshToken';
import { UserResponseDto } from '@/model/generated';
import { LanguageLocale } from '@/model/language-locale';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { switchLocale } = useI18n();

const router = useRouter();
const route = useRoute();
const initialized = ref(false);

useRefreshToken();

const adjustViewport = () => {
  const minimumWidth = 410;
  const screenWidth = window.outerWidth;
  const viewportEl = document.querySelector('meta[name="viewport"]');

  if (!viewportEl) {
    return;
  }

  if (screenWidth < minimumWidth) {
    const scale = Number((screenWidth / minimumWidth).toFixed(3));
    viewportEl.setAttribute(
      'content',
      `width=device-width, initial-scale=${scale}, user-scalable=no`
    );
  } else {
    viewportEl.setAttribute('content', 'width=device-width,initial-scale=1.0');
  }
};

onBeforeMount(async () => {
  adjustViewport();

  window.addEventListener('resize', () => {
    adjustViewport();
  });

  await router.isReady();

  let locale = route.query.locale || DEFAULT_LOCALE;

  if (Array.isArray(locale)) {
    locale = locale[0] as string;
  }

  // allow only supported locales
  if (!Object.keys(UserResponseDto.locale).includes(locale.toUpperCase())) {
    locale = DEFAULT_LOCALE;
  }

  await switchLocale(locale.toLowerCase() as LanguageLocale).then(() => {
    initialized.value = true;
  });

  document.adoptedStyleSheets.push(typescaleStyles.styleSheet as CSSStyleSheet);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (initialized.value)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(route).meta.layout), { key: 0 }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_router_view, {
            key: _unref(route).fullPath
          }))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})